import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { tenantActions } from '../../redux/tenant.actions';
import { getHoldingDepositStatusData, getHoldingDepositStatusData1, getRentalOfferStatus, showSuccesToast } from '../helpers';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import getPlatformType from '../../../../helpers/helpers';

const HoldingStatusTable = ({ ten = [], flowId = '', buttonText, onRightClick, holding_amount = 0, collectDeposit }) => {
  console.log("teanats", ten)
  const dispatch = useDispatch()
  const _confirmReceipt = (data) => {
    dispatch(tenantActions.confirmDeposit(data, flowId));
  };

  const _revokeConfirmReceipt = (data) => {
    dispatch(tenantActions.revokeConfirmationDeposit(data, flowId));
  };
  const _confirmReceiptAll = () => {
    let arr = [];
    ten?.forEach((data) => {
      arr.push(data?.open_flow_sub_tenant_id);
    });

    _confirmReceipt({ flow_id: flowId, open_flow_sub_tenant_id: arr });
  };
  const layoutType = getPlatformType()
  return (
    <View style={styles.card}>
      <View style={{ flexDirection:layoutType=="web"? "row":"column", justifyContent: "space-between", marginBottom: 10 }}>
        <Text style={styles.title}>Receiving Holding Deposit</Text>
        <View style={{ flexDirection: "row" ,justifyContent:"flex-end"}}>
          <TouchableOpacity
            onPress={() => { onRightClick() }}
            style={[styles.nudgeButton, { marginRight: 8 }]}>
            <Text style={styles.nudgeText}>{buttonText}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => { _confirmReceiptAll() }}
            style={[styles.nudgeButton, { backgroundColor: "rgb(23, 215, 106)" }]}>
            <Text style={styles.nudgeText}>Confirm All</Text>
          </TouchableOpacity>
        </View>

      </View>

      <ScrollView horizontal showsHorizontalScrollIndicator={true} contentContainerStyle={{ minWidth: '100%' }}>
      <View style={styles.table}>
        {/* Header */}
        <View style={[styles.row, styles.headerRow]}>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Tenant</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Status</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Requested On</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Received On</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Confirmed On</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Action</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Nudge</Text>
          </View>
          <View style={styles.cell}>
            <Text style={styles.headerText}>Holding Deposit amount (£)</Text>
          </View>
        </View>

        {/* Rows */}
        {ten.map((tenant, index) => (
          <View key={index} style={styles.row}>
            <View style={styles.cell}>
              <Text>{tenant?.app_user?.user?.first_name} {tenant?.app_user?.user?.last_name}</Text>
            </View>

            <View style={styles.cell}>
              <View
                style={[
                  styles.statusContainer,
                  { borderColor: getHoldingDepositStatusData1(tenant?.deposit_payment_status).borderColor },
                ]}
              >
                <Text style={{
                  color: getHoldingDepositStatusData1(tenant?.deposit_payment_status).borderColor,
                  fontSize: 14,
                  textAlign: "center"
                }}>
                  {getHoldingDepositStatusData1(tenant?.deposit_payment_status).Text}
                </Text>
              </View>
            </View>
            <View style={styles.cell}>
              <Text>
                {tenant.deposit_sent_at ? moment(tenant.deposit_sent_at).format('DD/MM/YYYY')
                  : '-'}</Text>
            </View>
            <View style={styles.cell}>
              <Text>
                {tenant.date_received_deposit ? moment(tenant.date_received_deposit).format('DD/MM/YYYY')
                  : '-'}</Text>
            </View>
            <View style={styles.cell}>
              <Text>
                {tenant.deposit_accepted_at ? moment(tenant.deposit_accepted_at).format('DD/MM/YYYY')
                  : '-'}</Text>
            </View>
            <View style={styles.cell}>
              <TouchableOpacity
                onPress={() => {

                  tenant?.deposit_payment_status != 3 ?
                    _confirmReceipt({
                      flow_id: tenant?.openflow_id,
                      open_flow_sub_tenant_id: [tenant?.open_flow_sub_tenant_id],
                    })
                    :
                    _revokeConfirmReceipt({
                      flow_id: tenant?.openflow_id,
                      open_flow_sub_tenant_id: [tenant?.open_flow_sub_tenant_id],
                    })
                }}
                style={[styles.nudgeButton, { backgroundColor: getHoldingDepositStatusData1(tenant?.deposit_payment_status).borderColor }]}>
                <Text style={styles.nudgeText}>{tenant?.deposit_payment_status != 3 ? 'Confirm' : 'Revoke'}</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.cell}>
              <TouchableOpacity
                onPress={() => {
                  dispatch(tenantActions.rtrReminder(
                    { "flow_id": flowId, "open_flow_sub_tenant_id": [tenant?.app_user_id] }
                    , flowId, () => {
                      showSuccesToast('Reminder sent successfully!')
                    }, "/openflow/requestHoldingDeposit?"))
                }}
                style={styles.nudgeButton}>
                <Text style={styles.nudgeText}>NUDGE</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.cell}>
              <Text>
                {
                  holding_amount
                    ? collectDeposit
                      ? tenant?.is_lead
                        ? holding_amount
                        : 0
                      : (holding_amount / ten?.length).toFixed(2)
                    : 'N/A'
                }</Text>
            </View>


          </View>
        ))}
      </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    padding: 16,
    backgroundColor: 'white',
    borderRadius: 12,
    elevation: 2,
    marginTop: 10
  },
  title: {
    fontSize: 16,
    color: '#3f51b5',
    fontWeight: '600',
    marginBottom: 12,
  },
  table: {
    minWidth: 980, // Ensures horizontal scroll works on smaller screens
    width: '100%',
    overflow:"scroll"
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 0.5,
    borderBottomColor: '#ddd',
    paddingVertical: 12,
  },
  headerRow: {
    backgroundColor: '#f5f5f5',
  },
  cell: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 8,
  },
  headerText: {
    fontWeight: '600',
  },
  statusContainer: {
    borderWidth: 1,
    borderRadius: 12,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',

  },
  nudgeButton: {
    backgroundColor: '#9b5de5',
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },
  nudgeText: {
    color: 'white',
    fontWeight: '600',
  },
});

export default HoldingStatusTable;
